import { Language } from './../../../util/lang';
import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { Provider } from 'src/app/models/provider';

@Component({
  selector: 'app-provider-item',
  templateUrl: './provider-item.component.html',
  styleUrls: ['./provider-item.component.scss']
})
export class ProviderItemComponent implements OnInit {

  @Input() Provider: Provider;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigateTo(Provider): void {
    const lang = Language.getCurrentLang();
    const { Leaf, GUID } = Provider;
    let path;
    if (Leaf == 0) {
      path = `${lang}/providers`;
    } else if (Leaf == 1) {
      path = `${lang}/provider`;
    }
    this.router.navigate([`${path}/${GUID}`]);
  }

}
